import {
  APIGetRequest,
  APIPostRequest,
  APIPutRequest,
  CompanyMemberAccountCreatePayload,
  CompanyMemberAccountCreateResponse,
  CompanyMemberInvitation,
  CompanyMemberPatchPayload,
  CompanyMemberSendEmailsPayload,
  CompanyMemberUpdateResponse,
} from '@ancon/wildcat-types'

import endpoints from '../endpoints'
import Request from '../../client/Request'
import { APIType } from '../../types'
import { CompanyQRExtentCompanyMember } from '../../../features/account/types'

type CompaniesAPI = {
  get: {
    memberDetails: APIGetRequest<
      CompanyQRExtentCompanyMember,
      {
        tenantId: string
        companyId: string
        memberId: string
        'extent.companyQRCode'?: boolean
      }
    >
    verifyMemberInvitation: APIGetRequest<
      CompanyMemberInvitation,
      { invitationToken: string }
    >
  }
  put: {
    createMemberAccount: APIPutRequest<
      CompanyMemberAccountCreateResponse,
      CompanyMemberAccountCreatePayload,
      { companyId: string; memberId: string }
    >
  }
  patch: {
    updateCompanyMember: APIPutRequest<
      CompanyMemberUpdateResponse,
      CompanyMemberPatchPayload,
      { companyId: string; memberId: string }
    >
  }
  post: {
    sendMemberEmails: APIPostRequest<
      {},
      CompanyMemberSendEmailsPayload,
      { companyId: string; memberId: string }
    >
  }
}

const companies: CompaniesAPI = {
  get: {
    memberDetails: new Request(
      endpoints.user.tenants.byId.companies.byId.members.byId.details,
      {
        apiType: APIType.User,
      },
    ).get,
    verifyMemberInvitation: new Request(
      endpoints.user.companies.members.verifyInvitation.list,
      {
        apiType: APIType.User,
      },
    ).get,
  },
  put: {
    createMemberAccount: new Request(
      endpoints.user.companies.byId.members.byId.details,
      {
        apiType: APIType.User,
      },
    ).put,
  },
  patch: {
    updateCompanyMember: new Request(
      endpoints.user.companies.byId.members.byId.details,
      {
        apiType: APIType.User,
      },
    ).patch,
  },
  post: {
    sendMemberEmails: new Request(
      endpoints.user.companies.byId.members.byId.sendEmails.list,
      {
        apiType: APIType.User,
      },
    ).post,
  },
}

export default companies
